var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ButtonLogout",on:{"click":function($event){$event.preventDefault();return _vm.handleLogout($event)}}},[_c('img',{attrs:{"src":require("@/assets/logout.svg")}}),_vm._v(" Logout ")])}
var staticRenderFns = []

export { render, staticRenderFns }